<template>
  <div id="app" style="height: 100%;">
    <div class="gr-loading-view align-self-end gr-loading gr-loading-bg w-100 h-100 position-absolute" :style="isLoading ? {
      visibility: 'visible',
      'min-height': heightOfContent,
      'z-index': zIndex
    } : {
      visibility: 'hidden',
      'min-height': heightOfContent,
      'z-index': zIndex
    }">
        <img style="width: calc(min(10vw, 50px))" src="/gr-loading.gif">
    </div>
    <div style="height: 100%; width: 100vw;">
      <AppHeader style="position: fixed; top: 0; width: 100%;"></AppHeader>
      <div id="main-content" style="z-index: 400; height: 100%; background: #D3E9E2;" role="main">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <UiToast
      v-if="currentToast"
      :message="currentToast.message"
      :duration="currentToast.duration"
      @close="removeToast(currentToast.id)"
    />
  </div>
</template>

<script>
import AppHeader from './Header.vue'
import UiToast from '@/components/UiToast'

export default {
  name: 'AppLayout',
  components: {
    AppHeader,
    UiToast
  },
  data () {
    return {
      defaultContentHeight: '100vw'
    }
  },
  computed: {
    isLoading: function () {
      const load = this.$store.getters['loading/isLoadingApp']
      return load
    },
    isInitLoading: function () {
      return this.$store.getters['loading/isInitLoadingApp']
    },
    navBarHeight () {
      return this.$store.getters['dom/navBarHeight']
    },
    heightOfContent: function () {
      return this.isInitLoading ? '100vh' : `calc(${window.innerHeight}-${this.navBarHeight}px)`
    },
    marginTop: function () {
      return this.isInitLoading ? '0px' : `${this.navBarHeight}px`
    },
    zIndex: function () {
      return this.isInitLoading ? '1000' : '700'
    },
    currentToast: function () {
      const list = this.$store.state.toast.toastsList
      return list.length > 0 ? list[0] : null
    }
  },
  methods: {
    removeToast (id) {
      this.$store.commit('toast/REMOVE', { id })
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
  .gr-loading-view {
    transition: .5s ease;
  }
  .gr-loading-bg {
    background: $color-gr-turquoise;
    opacity: 0.99;
  }
</style>
